import React from "react";
import { Global, css } from "@emotion/core";
import { breakpoints, fonts } from "./vars";
import { at } from "./utils";

import TitleFont from "../fonts/ZeitungMonoPro-Bold.woff2";
import BodyFont from "../fonts/ZeitungMonoPro-Regular.woff2";

import ArabicTitleFont from "../fonts/Cairo-Bold.woff2";
import ArabicBodyFont from "../fonts/Cairo-Regular.woff2";

import reset from "./reset";

const styles = css`
  ${reset}
  @font-face {
    font-family: "ZeitungMonoPro-Bold";
    src: url(${TitleFont}) format("woff2");
    font-weight: normal;
    font-style: normal;
  }

  @font-face {
    font-family: "ZeitungMonoPro-Reg";
    src: url(${BodyFont}) format("woff2");
    font-weight: normal;
    font-style: normal;
  }
  @font-face {
    font-family: "Cairo-Regular";
    src: url(${ArabicBodyFont}) format("woff2");
    font-weight: normal;
    font-style: normal;
  }

  @font-face {
    font-family: "Cairo-Bold";
    src: url(${ArabicTitleFont}) format("woff2");
    font-weight: normal;
    font-style: normal;
  }

  html,
  body {
    height: 100%;
    width: 100%;
    overflow: scroll;
  }

  body {
    font-family: ${fonts.regular};
    font-size: 12px;
    background: #000;
    color: #fff;
    ${at(breakpoints.desktop)} {
      font-size: 16px;
    }
  }

  p {
    margin: 0 0 1.5em;
  }

  a {
    color: #fff;
  }

  strong {
    font-family: ${fonts.bold};
  }
`;
// eslint-disable-next-line react/display-name
export default () => <Global styles={styles} />;
